import { render, staticRenderFns } from "./newPeriodicity.vue?vue&type=template&id=670a64bb&scoped=true"
import script from "./newPeriodicity.vue?vue&type=script&lang=js"
export * from "./newPeriodicity.vue?vue&type=script&lang=js"
import style0 from "./newPeriodicity.vue?vue&type=style&index=0&id=670a64bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a64bb",
  null
  
)

export default component.exports